class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (window.CollectionPerPageSync) window.CollectionPerPageSync();
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (window.CollectionPerPageSync) window.CollectionPerPageSync();
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    if (event.target && event.target.closest('#per-page-select, #per-page-select-mobile, .per-page-select-sync')) {
      return;
    }
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

const CollectionPerPage = {
  VALID: ['20', '50', '75', '100'],
  BASE_PAGE_SIZE: 20,
  activeRequestId: 0,

  getState() {
    const url = new URL(window.location.href);
    const perPage = url.searchParams.get('products_per_page');
    const page = Number.parseInt(url.searchParams.get('page') || '1', 10);

    return {
      perPage: this.VALID.includes(perPage) ? Number.parseInt(perPage, 10) : this.BASE_PAGE_SIZE,
      page: Number.isFinite(page) && page > 0 ? page : 1,
    };
  },

  getGrid() {
    return document.getElementById('product-grid');
  },

  getSectionId() {
    return this.getGrid()?.dataset.id || '';
  },

  getTotalCount() {
    const grid = this.getGrid();
    const fromData = Number.parseInt(grid?.dataset.totalCount || '', 10);
    if (Number.isFinite(fromData) && fromData > 0) {
      return fromData;
    }

    const countElement = document.getElementById('ProductCountDesktop') || document.getElementById('ProductCount');
    const matches = (countElement?.textContent || '').match(/\d+/g);
    if (matches?.length) {
      return Number.parseInt(matches[matches.length - 1], 10) || 0;
    }

    return grid ? grid.querySelectorAll(':scope > li.grid__item').length : 0;
  },

  updateControls() {
    const { perPage } = this.getState();
    const value = String(perPage);

    document
      .querySelectorAll('#per-page-select, #per-page-select-mobile, .per-page-select-sync')
      .forEach((select) => {
        select.value = value;
      });

    document.querySelectorAll('input[name="products_per_page"]').forEach((input) => {
      input.value = value;
    });
  },

  buildLogicalUrl(page, perPage) {
    const url = new URL(window.location.href);
    url.searchParams.set('products_per_page', String(perPage));
    if (page > 1) {
      url.searchParams.set('page', String(page));
    } else {
      url.searchParams.delete('page');
    }
    return url;
  },

  buildPaginationParts(currentPage, totalPages) {
    const candidates = [1, currentPage - 1, currentPage, currentPage + 1, totalPages];
    const uniquePages = [...new Set(candidates.filter((page) => page >= 1 && page <= totalPages))].sort(
      (left, right) => left - right
    );

    const parts = [];
    uniquePages.forEach((page) => {
      if (parts.length && page - parts[parts.length - 1] > 1) {
        parts.push('ellipsis');
      }
      parts.push(page);
    });

    return parts;
  },

  renderPagination(currentPage, totalPages, perPage) {
    const wrapper = document.querySelector('.pagination-wrapper');
    if (!wrapper) {
      return;
    }

    if (totalPages <= 1) {
      wrapper.innerHTML = '';
      wrapper.style.display = 'none';
      return;
    }

    wrapper.style.display = '';
    const parts = this.buildPaginationParts(currentPage, totalPages);
    let html = '<nav class="pagination" role="navigation" aria-label="Pagination"><ul class="pagination__list list-unstyled" role="list">';

    if (currentPage > 1) {
      const previousUrl = this.buildLogicalUrl(currentPage - 1, perPage);
      html += `<li><a href="${previousUrl.toString()}" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce" aria-label="Previous page"><span aria-hidden="true">&larr;</span></a></li>`;
    }

    parts.forEach((part) => {
      if (part === 'ellipsis') {
        html += '<li><span class="pagination__item">&hellip;</span></li>';
        return;
      }

      if (part === currentPage) {
        html += `<li><a role="link" aria-disabled="true" class="pagination__item pagination__item--current light" aria-current="page" aria-label="Page ${part}">${part}</a></li>`;
        return;
      }

      const pageUrl = this.buildLogicalUrl(part, perPage);
      html += `<li><a href="${pageUrl.toString()}" class="pagination__item link" aria-label="Page ${part}">${part}</a></li>`;
    });

    if (currentPage < totalPages) {
      const nextUrl = this.buildLogicalUrl(currentPage + 1, perPage);
      html += `<li><a href="${nextUrl.toString()}" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce" aria-label="Next page"><span aria-hidden="true">&rarr;</span></a></li>`;
    }

    html += '</ul></nav>';
    wrapper.innerHTML = html;
  },

  async fetchSectionPage(serverPage, requestId) {
    const sectionId = this.getSectionId();
    if (!sectionId) {
      return '';
    }

    const url = new URL(window.location.href);
    url.searchParams.delete('products_per_page');
    url.searchParams.set('page', String(serverPage));
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('_pp_nonce', `${requestId}-${serverPage}-${Date.now()}`);

    const response = await fetch(url.toString(), {
      credentials: 'same-origin',
      cache: 'no-store',
    });

    return response.text();
  },

  async sync() {
    this.updateControls();

    const { perPage } = this.getState();
    if (perPage <= this.BASE_PAGE_SIZE) {
      return;
    }

    const totalCount = this.getTotalCount();
    if (!totalCount) {
      return;
    }

    const totalPages = Math.max(1, Math.ceil(totalCount / perPage));
    let { page } = this.getState();
    if (page > totalPages) {
      page = totalPages;
      history.replaceState(
        { searchParams: this.buildLogicalUrl(page, perPage).searchParams.toString() },
        '',
        this.buildLogicalUrl(page, perPage).toString()
      );
    }

    const grid = this.getGrid();
    const expectedCount = Math.min(perPage, totalCount - (page - 1) * perPage);
    const renderedCount = grid ? grid.querySelectorAll(':scope > li.grid__item').length : 0;
    const renderedLogicalPage = Number.parseInt(grid?.dataset.logicalPage || '', 10);
    const renderedLogicalPerPage = Number.parseInt(grid?.dataset.logicalPerPage || '', 10);

    if (renderedCount === expectedCount && renderedLogicalPage === page && renderedLogicalPerPage === perPage) {
      this.renderPagination(page, totalPages, perPage);
      return;
    }

    const startOffset = (page - 1) * perPage;
    const endOffsetExclusive = Math.min(startOffset + perPage, totalCount);
    const firstServerPage = Math.floor(startOffset / this.BASE_PAGE_SIZE) + 1;
    const lastServerPage = Math.floor((Math.max(endOffsetExclusive - 1, startOffset)) / this.BASE_PAGE_SIZE) + 1;
    const requestId = ++this.activeRequestId;

    const sectionHtml = await Promise.all(
      Array.from({ length: lastServerPage - firstServerPage + 1 }, (_, index) =>
        this.fetchSectionPage(firstServerPage + index, requestId)
      )
    );

    if (requestId !== this.activeRequestId) {
      return;
    }

    const cards = [];
    sectionHtml.forEach((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      doc.querySelectorAll('#product-grid > li.grid__item').forEach((item) => {
        cards.push(item.outerHTML);
      });
    });

    const sliceStart = startOffset - (firstServerPage - 1) * this.BASE_PAGE_SIZE;
    const visibleCards = cards.slice(sliceStart, sliceStart + perPage);

    if (!grid) {
      return;
    }

    grid.innerHTML = visibleCards.join('');
    grid.dataset.logicalPage = String(page);
    grid.dataset.logicalPerPage = String(perPage);
    this.updateControls();
    this.renderPagination(page, totalPages, perPage);
  },
};

const COLLECTION_PER_PAGE_SELECTOR = '#per-page-select, #per-page-select-mobile, .per-page-select-sync';

function getCollectionPerPageSelect(target) {
  if (!(target instanceof Element)) {
    return null;
  }

  return target.closest(COLLECTION_PER_PAGE_SELECTOR);
}

function startCollectionPerPageSync() {
  window.CollectionPerPageSync();
  window.setTimeout(() => {
    window.CollectionPerPageSync();
  }, 150);
}

function handleCollectionPerPageSelection(value) {
  if (!CollectionPerPage.VALID.includes(value)) {
    return;
  }

  const perPage = Number.parseInt(value, 10);
  const targetUrl = CollectionPerPage.buildLogicalUrl(1, perPage);
  history.pushState({ searchParams: targetUrl.searchParams.toString() }, '', targetUrl.toString());
  CollectionPerPage.updateControls();

  if (perPage <= CollectionPerPage.BASE_PAGE_SIZE) {
    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
      FacetFiltersForm.renderPage(targetUrl.searchParams.toString(), null, false);
      return;
    }

    window.location.assign(targetUrl.toString());
    return;
  }

  startCollectionPerPageSync();
}

window.CollectionPerPageSync = () => {
  return CollectionPerPage.sync().catch((error) => {
    console.error('Unable to sync the collection per-page view.', error);
  });
};

document.addEventListener(
  'input',
  (event) => {
    if (!getCollectionPerPageSelect(event.target)) {
      return;
    }

    event.stopImmediatePropagation();
  },
  true
);

document.addEventListener(
  'change',
  (event) => {
    const select = getCollectionPerPageSelect(event.target);
    if (!select) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    handleCollectionPerPageSelection(select.value);
  },
  true
);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startCollectionPerPageSync);
} else {
  startCollectionPerPageSync();
}

window.addEventListener('load', startCollectionPerPageSync);
document.addEventListener('shopify:section:load', startCollectionPerPageSync);
